import { useEffect, useState } from "react";

import { getDeliverOrders } from "../../service/api/StaffOrder/apiStaffOrder";
import { StaffOrderSheet } from "../../components/StaffOrder";
import { useUser } from "../../hooks/useUser";

const StaffOrderInfo = () => {
     const { companyId } = useUser();
     const [mode, setMode] = useState(companyId ? 'company' : 'personal');
    const [ordersData, setOrdersData] = useState([]);
    const [dataCount, setDataCount] = useState(0);
    useEffect(() => {
        getDeliverOrders({ page: 1, limit: 10, mode })
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setOrdersData(response.data.result);
                    setDataCount(response.data.count);
                }
            });
    }, [mode]);
    return (
        <>
            <div className="deliverinfo container mt-4">
                <div className="card shadow p-4 border-0">
                    <h4 className="mb-3 text-primary fw-bold">員工派車單</h4>
                    <div className="col-lg-12 mb-4">
                        <div className="card">
                            <StaffOrderSheet
                                data={ordersData}
                                mode={mode}
                                setMode={setMode}
                                dataCount={dataCount}
                                setDataCount={setDataCount}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export { StaffOrderInfo }